import React from 'react';
import { Modal, Button, message, ConfigProvider } from 'antd';
import { useMutation } from '@apollo/client';
import {
  TRANSFER_OWNERSHIP,
  TransferOwnershipMutationVariables,
  TransferOwnershipMutationResponse,
} from './Users';
import { AUTH_API_URL } from './SpaceAssignments';

interface TransferOwnershipModalProps {
  open: boolean;
  userId: string;
  userName: string;
  onCancel: () => void;
  onSuccess: () => void;
}

export const TransferOwnershipModal: React.FC<TransferOwnershipModalProps> = ({
  open,
  userId,
  userName,
  onCancel,
  onSuccess,
}) => {
  const [transferOwnership, { loading }] = useMutation<
    TransferOwnershipMutationResponse,
    TransferOwnershipMutationVariables
  >(TRANSFER_OWNERSHIP, {
    context: { uri: AUTH_API_URL },
  });

  const handleConfirm = async () => {
    try {
      await transferOwnership({
        variables: { newOwnerId: userId },
      });
      message.success(`Ownership transferred to ${userName}`);
      onSuccess();
    } catch (err) {
      console.error('Failed to transfer ownership:', err);
      const errorMessage = err instanceof Error ? err.message : 'Failed to transfer ownership';
      message.error(errorMessage);
    }
  };

  return (
    <Modal
      title="Transfer Ownership"
      open={open}
      onCancel={onCancel}
      footer={null}
      width={520}
      centered
    >
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#24252C',
          },
        }}
      >
        <div className="py-3">
          <p className="text-sm leading-[22px] text-gray-900">
            <span className="font-semibold">{userName}</span> will become the new owner and have
            full control of user management. Your role will become an Admin.
          </p>
        </div>
        <div className="flex justify-end gap-2 pt-3">
          <Button onClick={onCancel} disabled={loading}>
            Cancel
          </Button>
          <Button
            type="primary"
            onClick={handleConfirm}
            loading={loading}
            disabled={loading}
            className="!bg-[#24252C] !border-[#24252C] !text-white hover:!bg-[#3a3b44]"
          >
            Confirm
          </Button>
        </div>
      </ConfigProvider>
    </Modal>
  );
};

export default TransferOwnershipModal;
